import { FC } from 'react';
import { Box, CircularProgress } from '@mui/material';

interface Props {
  minHeight?: number;
}

export const Loader: FC<Props> = ({ minHeight = 300 }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
      minHeight={minHeight}
    >
      <CircularProgress color="primary" disableShrink />
    </Box>
  );
};
